// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* START: Onboarding */
.BC-page_Installation img {
  image-rendering: pixelated;
}

.BC-page_Installation .ButtonCustom .Polaris-Button {
  padding: 14px 30px;
  height: 48px;
  background: #ff3000;
  box-shadow: 0px 4px 24px rgba(235, 69, 38, 0.4);
  border-radius: 4px;
  border: 0;
  min-width: 110px;
}

.BC-page_Installation .ButtonCustom .Polaris-Button:hover {
  background: #e82c00;
}

.BC-page_Installation .ButtonCustom .Polaris-Button .Polaris-Button__Text {
  color: white;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: 'Poppins', sans-serif;
}

.BC-page_Installation .ButtonCustom.disabled .Polaris-Button {
  box-shadow: none;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  cursor: not-allowed;
}

.BC-page_Installation .ButtonCustom.disabled .Polaris-Button .Polaris-Button__Text {
  color: #8c9196;
}

.BC-page_Installation.Onboarding *,
.BC-page_Installation.KYC *,
.BC-page_Installation.SuccessInstall * {
  font-family: 'Poppins', sans-serif;
}

.BC-page_Installation.Onboarding:has(.NewUser) * {
  font-family: 'SF Pro Text';
}

.BC-page_Installation.Onboarding .NewUser .title {
  font-family: 'SF Pro Display', 'Poppins';
}

.BC-page_Installation.Onboarding .NewUser .description {
  font-family: 'SF Pro Text';
}

.BC-page_Installation.Onboarding .Polaris-Card {
  max-width: 1120px;
  width: calc(100% - 40px * 2);
  margin: 0 auto;
  max-height: 600px;
}

.BC-page_Installation .BC-page_Installation--Onboarding {
  height: 100%;
  max-height: 600px;
}

.BC-page_Installation .BC-page_Installation--Onboarding,
.BC-page_Installation .BC-page_Installation--Onboarding .wrapper {
  display: flex;
  position: relative;
}

.BC-page_Installation .BC-page_Installation--Onboarding .control-dots {
  display: flex;
  justify-content: center;
  align-items: center;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper {
  display: flex;
  flex-direction: row-reverse;
  border-radius: 10px;
  max-height: 600px;
  width: 100%;
  justify-content: space-between;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview,
.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview img {
  border-radius: 0 10px 10px 0;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre,
.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {
  position: absolute;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: white;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre {
  transform: translateY(-50%);
  left: -22px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {
  transform: translateY(-50%);
  right: -22px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .select-feature {
  max-height: 600px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview {
  width: 50%;
  max-width: 576px;
  height: 100%;
  flex-shrink: 0;
  max-height: 600px;
  overflow: hidden;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview img {
  height: 100%;
  margin-left: auto;
  display: flex;
  width: 100%;
  max-width: 100%;
  object-fit: cover;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content {
  width: auto;
  position: relative;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .form-select-theme {
  width: 100%;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .form-onboarding-plan {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .form-email-opt {
  padding: 80px 40px;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content {
  display: flex;
  flex-direction: column;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content .features {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content .features > div {
  display: flex;
  gap: 8px;
}

@media (max-width: 1440px) {
  .BC-page_Installation
    .BC-page_Installation--Onboarding.NewUser
    .wrapper
    .content.form-email-opt
    .subtitle {
    margin-top: 32px !important;
    font-size: 28px !important;
    line-height: 30px !important;
  }

  .BC-page_Installation
    .BC-page_Installation--Onboarding.NewUser
    .wrapper
    .content.form-email-opt
    .title {
    font-size: 36px !important;
    line-height: 40px !important;
  }

  .BC-page_Installation.Select-Theme .NewUser .form-select-features {
    padding: 24px !important;
    gap: 16px !important;
  }

  .BC-page_Installation
    .BC-page_Installation--Onboarding
    .wrapper
    .content
    .onboarding-features
    .feature-item {
    height: 286px !important;
  }

  .BC-page_Installation .BC-page_Installation--Onboarding .form-select-features .title {
    font-size: 24px !important;
    line-height: 28px !important;
  }

  .BC-page_Installation
    .BC-page_Installation--Onboarding
    .wrapper
    .content
    .onboarding-features
    .feature-item
    .label {
    font-size: 12px !important;
  }
}
@media (max-width: 1280px) {
  .BC-page_Installation
    .BC-page_Installation--Onboarding.NewUser
    .wrapper
    .content.form-email-opt
    .subtitle {
    margin-top: 32px !important;
    font-size: 22px !important;
    line-height: 24px !important;
  }

  .BC-page_Installation
    .BC-page_Installation--Onboarding.NewUser
    .wrapper
    .content.form-email-opt
    .title {
    font-size: 30px !important ;
    line-height: 32px !important ;
  }
}

@media (max-width: 1120px) {
  .BC-page_Installation .form-select-templates .list-templates li {
    width: 200px !important;
    min-width: 200px !important;
  }

  .BC-page_Installation .form-select-templates .list-templates .item img,
  .BC-page_Installation .form-select-templates .list-templates .item .image {
    max-width: 200px !important;
    max-height: 150px !important;
  }

  .BC-page_Installation .form-select-templates ul {
    column-gap: 48px !important;
  }

  .BC-page_Installation
    .form-select-templates
    .list-templates
    .item
    .template-name
    .Polaris-Badge--statusInfo {
    min-width: 93px !important;
  }
}

@media (max-width: 1112px) {
   .BC-page_Installation .form-select-templates ul {
    column-gap: 40px !important;
  }
}

@media (max-width: 1096px) {
   .BC-page_Installation .form-select-templates ul {
    column-gap: 32px !important;
  }
}

@media (max-width: 1080px) {
  .BC-page_Installation .form-select-templates ul {
    column-gap: 50px !important;
  }

  .BC-page_Installation .form-select-templates .list-templates li {
    width: 150px !important;
    min-width: 150px !important;
  }

  .BC-page_Installation .form-select-templates .list-templates .item .image>di:nth-child(1) {
    min-width: 150px !important;
    height: 150px !important;
  }
}


@media (max-width: 1024px) {
  .BC-page_Installation .Polaris-Card {
    width: 560px;
    max-width: 560px !important;
  }

  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper {
    flex-direction: column;
  }

  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre,
  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {
    top: 75%;
    z-index: 10;
  }

  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview img {
    border-radius: 10px 10px 0 0;
  }

  .BC-page_Installation .select-template-design .wrapper .form-select-templates {
    flex-direction: column;
  }

  .BC-page_Installation .select-template-design .wrapper .form-select-templates > div {
    width: 100% !important;
  }

  .BC-page_Installation.Onboarding.NewUser .Polaris-Card {
    width: 560px;
  }

  .BC-page_Installation .form-select-templates .list-templates li {
    width: 150px !important;
  }

  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper {
    flex-direction: column;
  }

  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .btn-pre,
  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .btn-next {
    top: 75%;
    z-index: 10;
  }

  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview {
    width: 100%;
  }

  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview img {
    border-radius: 10px 10px 0 0;
  }

  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content {
    background: white;
    border-radius: 0 0 10px 10px;
  }
}

@media (max-height: 620px) {
  .BC-page_Installation.Select-Theme > .Polaris-Card {
    max-height: calc(100% - 48px) !important;
    height: 550px !important;
  }
  .BC-page_Installation .wrapper .preview {
    height: 550px !important;
  }
  .BC-page_Installation.Select-Theme .NewUser .form-select-theme {
    padding: 60px 40px !important;
    max-height: 600px !important;
  }
  .BC-page_Installation .select-theme-simplify-running .preview {
    height: 100% !important;
  }
  .BC-page_Installation.Select-Theme .NewUser .form-select-theme {
    gap: 10px !important;
  }
  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .title {
    font-size: 26px !important;
  }
  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .desc {
    font-size: 12px !important;
  }

  .BC-page_Installation .form-select-templates .list-templates .Polaris-Scrollable {
    max-height: 500px !important;
  }
}

@media (max-height: 550px) {
  .BC-page_Installation.Select-Theme > .Polaris-Card,
  .BC-page_Installation,
  .BC-page_Installation .wrapper .preview {
    max-height: 500px !important;
    height: 500px !important;
  }
  .BC-page_Installation.Select-Theme .NewUser .form-select-theme {
    padding: 60px 40px !important;
    max-height: 500px !important;
  }
  .BC-page_Installation .select-theme-simplify-running .preview {
    height: 100% !important;
  }
  .BC-page_Installation.Select-Theme .NewUser .form-select-theme {
    gap: 10px !important;
  }
  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .title {
    font-size: 26px !important;
  }
  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .desc {
    font-size: 12px !important;
  }
}

.BC-page_Installation {
  padding: 24px;
}

@media (max-height: 490px) {
  .BC-page_Installation.Select-Theme .NewUser .installing {
    gap: 20px !important;
  }
}

.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-email-opt
  .title,
.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-onboarding-plan
  .title {
  text-align: left;
  font-family: 'SF Pro Display', sans-serif;
  font-size: 42px;
  font-weight: 700;
  line-height: 44px;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-onboarding-plan
  .title {
  margin-top: 0;
}
.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-email-opt
  .subtitle {
  margin-top: 64px;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-email-opt
  .subtitle,
.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-onboarding-plan
  .subtitle {
  text-align: left;
  margin-bottom: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
}

.BC-page_Installation.Onboarding form .Polaris-FormLayout__Item {
  padding-top: 8px;
  margin-top: unset;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-email-opt
  .desc {
  text-align: left;
  font-family: 'SF Pro Text', sans-serif;
  line-height: 20px;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-onboarding-plan
  .desc {
  text-align: left;
  margin-bottom: 24px;
  font-family: 'SF Pro Text', sans-serif;
  line-height: 20px;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-email-opt
  .Polaris-Label
  .Polaris-Label__Text {
  margin-bottom: 5px;
  font-weight: 400 !important;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-email-opt
  .Polaris-FormLayout
  input {
  min-height: 2.375rem;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-email-opt
  .Polaris-InlineError
  .Polaris-InlineError__Icon {
  display: block;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-email-opt
  .menu {
  position: static;
  display: block;
  margin-top: 25px;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding.NewUser
  .wrapper
  .content.form-onboarding-plan
  .menu {
  position: static;
  display: block;
  margin: 0;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .skip {
  text-align: right;
  font-weight: 400;
  font-size: 14px;
  color: #6d7175;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .skip span {
  cursor: pointer;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .badge {
  max-width: fit-content;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  border: 1px solid #eaecf0;
  border-radius: 16px;
  color: #344054;
  background: #f9fafb;
  padding: 2px 8px;
  margin-bottom: 10px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .title {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  color: #202223;
  display: flex;
  align-items: baseline;
  gap: 18px;
  margin-bottom: 8px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .description {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #202223;
  margin-top: 24px;
  padding: 0 10px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .description.step-5 {
  font-size: 30px;
  line-height: 40px;
  margin-top: 0px;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .step {
  margin-top: 150px;
  position: absolute;
  bottom: 200px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step,
.render-choice-2 .Polaris-ChoiceList__Choices li {
  display: flex;
  align-items: center;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step {
  justify-content: center;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step .item {
  width: 6px;
  height: 6px;
  background: #c9ccd0;
  margin: 3px;
  border-radius: 50%;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step .active {
  width: 10px;
  height: 10px;
  background: #ff3300;
  border-radius: 50%;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 50px;
  bottom: 100px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu .back {
  display: flex;
  position: absolute;
  left: 45px;
  align-items: center;
  cursor: pointer;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding
  .wrapper
  .content
  .menu
  .back
  .Polaris-Icon {
  width: 12px;
  height: unset;
  margin: 10px;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding
  .wrapper
  .content
  .menu
  .back
  .Polaris-Icon
  svg {
  fill: black;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding
  .wrapper
  .content
  .onboarding-features
  .list {
  display: flex;
  gap: 16px;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding
  .wrapper
  .content
  .onboarding-features
  .feature-item {
  gap: 8px;
  border-radius: 8px;
  margin-bottom: 12px;
  background: #fff6f2;
  cursor: pointer;
  width: calc(100% / 4 - 8px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  max-height: 305px;
  height: 305px;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding
  .wrapper
  .content
  .onboarding-features
  .feature-item
  .label {
  display: flex;
  align-items: start;
  padding: 20px;
  font-size: 14px;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding
  .wrapper
  .content
  .onboarding-features
  .feature-item
  .label
  .Polaris-Checkbox__Icon {
  background-color: #ff3000;
  border-radius: 6px;
}

.BC-page_Installation
  .BC-page_Installation--Onboarding
  .wrapper
  .content
  .onboarding-features
  .feature-item
  .desc {
  color: #6d7175;
}

.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features img {
  width: 100%;
  height: auto;
  position: absolute;
  z-index: 5px;
  bottom: 0;
}

.BC-page_Installation.KYC,
.BC-page_Installation.SuccessInstall {
  padding-bottom: 30px;
}

.BC-page_Installation.KYC .Polaris-Card,
.BC-page_Installation.SuccessInstall .Polaris-Card {
  max-width: 1160px;
  width: calc(100% - 20px * 2);
  margin: 20px auto;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper {
  display: flex;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content {
  flex: 1;
  padding: 40px 56px;
  position: relative;
  min-height: 600px;
  display: flex;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm {
  height: auto;
  position: relative;
  width: 100%;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .title {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  color: #202223;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .description {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #6d7175;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #8c9196;
  margin-top: 40px;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-title {
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  color: #202223;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-description {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #6d7175;
  margin-top: 8px;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-form {
  margin-top: 40px;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  margin-top: 50px;
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back {
  display: flex;
  position: absolute;
  left: 0;
  align-items: center;
  cursor: pointer;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back .Polaris-Icon {
  width: 12px;
  height: unset;
  margin: 10px;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back .Polaris-Icon svg {
  fill: black;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .preview {
  width: 440px;
}

.BC-page_Installation .BC-page_Installation--KYC .wrapper .preview img {
  width: 440px;
  height: 100%;
  font-size: 0;
  line-height: 0;
  display: block;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 16px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item {
  min-height: 166px;
  width: 296px;
  position: relative;
  padding: 20px 12px 20px 20px;
  border: 2px solid #fafbfb;
  border-radius: 8px;
  background: #fafbfb;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item:hover {
  background: #fff8f6;
  cursor: pointer;
}

.BC-page_Installation
  .BC-page_Installation--KYC
  .SelectPlugin
  .SelectPlugin__Item:hover
  ~ .BC-page_Installation
  .BC-page_Installation--KYC
  .wrapper
  .preview {
  border: 4px solid red;
  border-color: var(--hover);
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .Polaris-Choice {
  position: absolute;
  right: 12px;
  top: 12px;
}

.BC-page_Installation
  .BC-page_Installation--KYC
  .SelectPlugin
  .SelectPlugin__Item
  .Polaris-Choice
  .Polaris-Checkbox__Backdrop {
  border: 1px solid #c9cccf;
  border-radius: 4px;
}

.BC-page_Installation
  .BC-page_Installation--KYC
  .SelectPlugin
  .SelectPlugin__Item
  .Polaris-Choice
  .Polaris-Checkbox__Backdrop::before {
  background-color: #ff3000;
}

.BC-page_Installation
  .BC-page_Installation--KYC
  .SelectPlugin
  .SelectPlugin__Item
  .Polaris-Choice
  .Polaris-Choice__Control {
  margin-right: 0;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .icon {
  width: 24px;
  height: 24px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #202223;
  margin-top: 8px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .description {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #6d7175;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item--Selected,
.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item--Selected:hover {
  border: 2px solid #ff8366;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectKind {
  margin-bottom: 20px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField__Input {
  min-height: 56px;
  border: px solid #a1a3ad;
  border-radius: 8px;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField {
  --p-focused: white;
  /* --p-focused: #FF3000; */
  border-radius: 10px;
}

.BC-page_Installation
  .BC-page_Installation--KYC
  .SelectKind
  .Polaris-TextField--focus
  .Polaris-TextField__Input {
  border: 2px solid #ff3000;
}

.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField__Backdrop {
  border-radius: 8px;
}

.BC-page_Installation .BC-page_Installation--KYC .IndustryList {
  padding: 2px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 10px;
  gap: 10px;
}

.BC-page_Installation .BC-page_Installation--KYC .IndustryItem {
  padding: 6px 8px;
  background: #f1f2f3;
  border-radius: 4px;
}

.BC-page_Installation .BC-page_Installation--KYC .IndustryItem:not(.IndustryItem__Selected) {
  cursor: pointer;
}

.BC-page_Installation .BC-page_Installation--KYC .IndustryItem__Selected {
  background: #ffefeb;
  color: #ff3000;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper {
  display: flex;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content {
  flex: 1;
  min-height: 600px;
  position: relative;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content {
  max-width: 540px;
  color: #202223;
  position: absolute;
  top: 50%;
  left: 50%;
  width: calc(100% - 80px);
  transform: translate(-50%, -50%);
}

.BC-page_Installation
  .BC-page_Installation--SuccessInstall
  .wrapper
  .content
  .inner-content
  .title {
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  margin-bottom: 35px;
}

.BC-page_Installation
  .BC-page_Installation--SuccessInstall
  .wrapper
  .content
  .inner-content
  .description,
.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .list {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 20px;
}

.BC-page_Installation
  .BC-page_Installation--SuccessInstall
  .wrapper
  .content
  .inner-content
  .description {
  margin-bottom: 16px;
}

.BC-page_Installation
  .BC-page_Installation--SuccessInstall
  .wrapper
  .content
  .inner-content
  .list
  .item {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.BC-page_Installation
  .BC-page_Installation--SuccessInstall
  .wrapper
  .content
  .inner-content
  .list
  img {
  margin-top: 4px;
}

.BC-page_Installation
  .BC-page_Installation--SuccessInstall
  .wrapper
  .content
  .inner-content
  .list
  .title2 {
  font-weight: 600;
}

.BC-page_Installation
  .BC-page_Installation--SuccessInstall
  .wrapper
  .content
  .inner-content
  .action {
  display: flex;
  gap: 10px;
}

.BC-page_Installation
  .BC-page_Installation--SuccessInstall
  .wrapper
  .content
  .inner-content
  .action
  > .Polaris-Button {
  border: 1px solid #292929;
  box-shadow: 0px 4px 24px 0px #eb452633;
}

.BC-page_Installation
  .BC-page_Installation--SuccessInstall
  .wrapper
  .content
  .inner-content
  .action
  > .Polaris-Button
  .Polaris-Button__Text {
  text-transform: uppercase;
  color: #292929;
  font-weight: 700;
  font-size: 14px;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview {
  width: 540px;
}

.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview img {
  width: 540px;
  height: 100%;
  font-size: 0;
  line-height: 0;
  display: block;
}

.BC-page_Installation .BC-page_Installation--KYC .IndustryList {
  margin-top: 20px;
}

.BC-page_Installation .BC-page_Installation--KYC .step4 {
  height: 100%;
  display: flex;
  align-items: center;
}

.BC-page_Installation .BC-page_Installation--KYC .step4-content .ButtonCustom {
  margin-top: 30px;
}

.BC-page_Installation .BC-page_Installation--KYC .step4-content .ButtonCustom .Polaris-Button {
  padding: 14px 20px;
}

@media (max-width: 1024px) {
  .BC-page_Installation.KYC .Polaris-Card,
  .BC-page_Installation.SuccessInstall .Polaris-Card {
    width: 560px;
  }
  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview {
    height: auto;
  }

  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview img {
    width: 100%;
  }

  .BC-page_Installation .BC-page_Installation--KYC .wrapper {
    flex-direction: column;
  }

  .BC-page_Installation .BC-page_Installation--KYC .wrapper .content {
    width: 100%;
    background: white;
    border-radius: 10px 10px 0 0;
  }

  .BC-page_Installation .BC-page_Installation--KYC .wrapper .preview {
    width: 100%;
    margin-top: -20px;
  }

  .BC-page_Installation .BC-page_Installation--KYC .wrapper .preview img {
    width: 100%;
    border-radius: 0 0 10px 10px;
  }

  .BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm {
    padding-bottom: 50px;
  }

  .BC-page_Installation .BC-page_Installation--KYC .SelectPlugin {
    justify-content: center;
    grid-template-columns: auto;
  }

  .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper {
    flex-direction: column;
  }

  .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content {
    width: 100%;
    background: white;
    border-radius: 10px 10px 0 0;
  }

  .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview {
    width: 100%;
    margin-top: -20px;
  }

  .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview img {
    width: 100%;
    border-radius: 0 0 10px 10px;
  }

  .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .StepForm {
    padding-bottom: 50px;
  }

  .BC-page_Installation
    .BC-page_Installation--Onboarding
    .wrapper
    .content
    .onboarding-features
    .list {
    flex-wrap: wrap !important;
    gap: 12px !important;
  }

  .BC-page_Installation
    .BC-page_Installation--Onboarding
    .wrapper
    .content
    .onboarding-features
    .feature-item {
    height: 300px;
    width: calc(100% / 2 - 8px);
  }
}

/* END: Onboarding */

.BC-page_Installation.ChooseTheme > .Polaris-Card {
  max-width: 1120px;
  width: calc(100% - 20px * 2);
  margin: 20px auto;
}

.BC-page_Installation.ChooseTheme > .Polaris-Card .BC-page_Installation--ChooseTheme .content-top {
  display: flex;
  padding: 30px 24px;
  align-items: center;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .info {
  flex: 1;
  width: auto;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .info
  .title {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  color: #202223;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .info
  .description {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #202223;
  margin-top: 12px;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .sync-info {
  width: 400px;
  padding-left: 20px;
  display: flex;
  justify-content: flex-end;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .sync-info
  .card {
  width: 349px;
  height: 108px;
  background: #fafbfb;
  border-radius: 8px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .sync-info
  .card
  .est {
  gap: 5px;
  display: flex;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .sync-info
  .card
  .percent {
  font-weight: 600;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .sync-info
  .title {
  display: flex;
  gap: 6px;
  align-items: center;
  font-weight: bold;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .sync-info
  .title
  img.loading {
  animation: rotation 2s infinite linear;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .sync-info
  .progress {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .sync-info
  .progressing {
  width: 250px;
  height: 8px;
  background: #e4e5e7;
  border-radius: 4px;
  display: inline-block;
  overflow: hidden;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-top
  .sync-info
  .progressing::before {
  width: var(--size);
  height: 8px;
  display: block;
  content: '';
  background: #008060;
}

.BC-page_Installation.ChooseTheme > .Polaris-Card .BC-page_Installation--ChooseTheme .content-main {
  border-bottom: 1px solid #e1e3e5;
  border-top: 1px solid #e1e3e5;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-main
  .Polaris-Card {
  border-radius: 0;
  box-shadow: unset;
  outline: unset;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-main
  .Polaris-Card
  .Polaris-Card__Section {
  padding-bottom: 0;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .Polaris-ChoiceList {
  padding-bottom: 12px;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .Polaris-ChoiceList__ChoiceItem {
  margin-top: 8px;
  margin-bottom: 8px;
}

@media (max-width: 40em) {
  .BC-page_Installation.ChooseTheme
    > .Polaris-Card
    .BC-page_Installation--ChooseTheme
    .Polaris-ChoiceList__ChoiceChildren {
    margin-top: 0;
  }
}

.BC-page_Installation.ChooseTheme .select-theme > div {
  width: 480px;
}

.BC-page_Installation.ChooseTheme .select-theme {
  width: 520px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-page_Installation.ChooseTheme .select-theme-warning {
  margin-top: 12px;
  color: #916a00;
}

.BC-page_Installation.ChooseTheme .select-theme > div {
  width: 480px;
}

.BC-page_Installation.ChooseTheme .feature-installed-info {
  color: #008060;
  margin-bottom: 10px;
}

.BC-page_Installation.ChooseTheme .title {
  padding-bottom: 0.5625rem;
}

.BC-page_Installation.ChooseTheme .list-features-select > div {
  margin-bottom: 12px;
}

.BC-page_Installation.ChooseTheme .select-recommedation-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 15px;
  margin-top: -15px;
}

.BC-page_Installation.ChooseTheme .BC-Theme-Setup_Form-Item {
  margin-bottom: var(--p-space-5);
}

.BC-page_Installation.ChooseTheme .Polaris-ChoiceList__ChoiceChildren {
  display: inline-block;
  vertical-align: top;
  padding-left: 0.625rem;
}

.BC-page_Installation.ChooseTheme .select-recommedation-wrapper div:nth-child(2) {
  width: 356px;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets {
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-bottom: 10px;
  min-height: 222px;
  padding: 17px;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading {
  font-weight: bold;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading,
.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row {
  display: flex;
  padding: 12px 0;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .data {
  max-height: 400px;
  overflow-y: auto;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(1),
.BC-page_Installation.ChooseTheme
  .ListRecommendationWidgets
  .wrapper
  .content
  .row
  div:nth-child(1) {
  width: 30px;
  display: flex;
  align-items: flex-start;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(2),
.BC-page_Installation.ChooseTheme
  .ListRecommendationWidgets
  .wrapper
  .content
  .row
  div:nth-child(2) {
  width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(3),
.BC-page_Installation.ChooseTheme
  .ListRecommendationWidgets
  .wrapper
  .content
  .row
  div:nth-child(3) {
  flex: 1;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(4),
.BC-page_Installation.ChooseTheme
  .ListRecommendationWidgets
  .wrapper
  .content
  .row
  div:nth-child(4) {
  width: 230px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BC-page_Installation.ChooseTheme
  .ListRecommendationWidgets
  .wrapper
  .content
  .row
  div:nth-child(4)
  img {
  cursor: pointer;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .data {
  height: 100%;
}

.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .empty {
  height: 190px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.BC-page_Installation.ChooseTheme .select-recommedation-widget .add-widget-action {
  text-align: right;
}

.BC-page_Installation.ChooseTheme .select-recommedation-widget .add-widget-action p {
  color: #2c6ecb;
  font-weight: 600;
  cursor: pointer;
}

.select-theme-refresh {
  height: 20px;
}

.BC-page_Installation.ChooseTheme .select-theme-refresh.refreshing {
  animation: rotation 2s infinite linear;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-bottom {
  display: flex;
  padding: 10px 24px;
  justify-content: space-between;
  align-items: center;
  border-radius: 0 0 0.5rem 0.5rem;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-bottom
  .description {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #6d7175;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-bottom
  .description
  i
  .Polaris-Link {
  text-decoration: none;
  color: #6d7175;
}

.BC-page_Installation.ChooseTheme
  > .Polaris-Card
  .BC-page_Installation--ChooseTheme
  .content-bottom
  .action {
}

@media (max-width: 768px) {
  .BC-page_Installation.ChooseTheme
    > .Polaris-Card
    .BC-page_Installation--ChooseTheme
    .content-top {
    flex-direction: column;
  }

  .BC-page_Installation.ChooseTheme
    > .Polaris-Card
    .BC-page_Installation--ChooseTheme
    .content-top
    .sync-info {
    padding: 20px 0;
    width: 100%;
    padding-bottom: 0;
  }

  .BC-page_Installation.ChooseTheme
    > .Polaris-Card
    .BC-page_Installation--ChooseTheme
    .content-top
    .sync-info
    .card {
    width: 100%;
  }

  .BC-page_Installation.ChooseTheme
    > .Polaris-Card
    .BC-page_Installation--ChooseTheme
    .content-top
    .sync-info
    .card
    .progressing {
    width: calc(100% - 45px);
  }

  .BC-page_Installation.ChooseTheme .select-theme {
    width: calc(100% - 20px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .BC-page_Installation.ChooseTheme .select-theme > div {
    width: 100%;
  }

  .BC-page_Installation.ChooseTheme .ListRecommendationWidgets {
    overflow-x: auto;
  }

  .BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper {
    min-width: 800px;
  }

  .BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(3),
  .BC-page_Installation.ChooseTheme
    .ListRecommendationWidgets
    .wrapper
    .content
    .row
    div:nth-child(3) {
    min-width: 200px;
  }
}

.BC-page_Installation.RunningSync > .Polaris-Card {
  max-width: 1120px;
  width: calc(100% - 20px * 2);
  margin: 20px auto;
}

.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .wrapper {
  display: flex;
  align-items: stretch;
}

.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .left {
  width: 520px;
  height: 708px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .left
  .left-img {
  width: 640px;
  height: 640px;
  z-index: 999;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .left
  .left-img
  img {
  width: 100%;
}

.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .left img {
  line-height: 0;
  font-size: 0;
  display: block;
}

.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .right {
  width: auto;
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .contact-us {
  position: absolute;
  bottom: 40px;
  left: 32px;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right-content {
  width: auto;
  flex: 1;
  padding: 32px;
  min-height: 440px;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right-content.skeleton {
  display: flex;
  align-items: center;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right-content
  .skeleton {
  height: 200px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-around;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right-content.has-inner {
  display: flex;
  align-items: center;
}

.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .right .title {
  font-size: 28px;
  line-height: 32px;
  color: #202223;
  margin-bottom: 10px;
  font-weight: 600;
  display: flex;
}

.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .dots {
  width: 30px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 4px;
}

.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .dots-3 {
  width: 5px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: d3 1s infinite linear alternate;
}

@keyframes d3 {
  0% {
    box-shadow:
      10px 0 #000,
      -10px 0 #0002;
    background: #000;
  }

  33% {
    box-shadow:
      10px 0 #000,
      -10px 0 #0002;
    background: #0002;
  }

  66% {
    box-shadow:
      10px 0 #0002,
      -10px 0 #000;
    background: #0002;
  }

  100% {
    box-shadow:
      10px 0 #0002,
      -10px 0 #000;
    background: #000;
  }
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .description {
  font-size: 14px;
  line-height: 20px;
  color: #202223;
  margin-bottom: 10px;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info
  .card {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info
  .title {
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  color: #202223;
  font-weight: 600;
  margin-bottom: 10px;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info
  .title
  span.refresh {
  display: inline-block;
  width: 18px;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info
  .title
  img.loading {
  animation: rotation 2s infinite linear;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info
  .progress {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info
  .progressing {
  height: 8px;
  width: 100%;
  background: #e4e5e7;
  border-radius: 4px;
  display: inline-block;
  overflow: hidden;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info
  .progressing::before {
  width: var(--size);
  height: 8px;
  display: block;
  content: '';
  background: #008060;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info
  .est {
  display: flex;
  justify-content: space-between;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info
  .est-wrap {
  display: flex;
  gap: 5px;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info
  .est-text {
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #6d7175;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .sync-info
  .est
  .percent {
  font-weight: 500;
  font-size: 14px;
  color: #202223;
}

.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .right .line {
  margin: 35px 0;
  width: 100%;
  height: 1px;
  border-top: 1px solid #e1e3e5;
}

.BC-page_Installation.RunningSync
  > .Polaris-Card
  .BC-page_Installation--RunningSync
  .right
  .Polaris-Button {
  margin-top: 15px;
  margin-right: 10px;
}

@media (max-width: 768px) {
  .BC-page_Installation.RunningSync > .Polaris-Card {
    max-width: 520px;
    margin-bottom: 20px;
    border-radius: 8px;
  }

  .BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .wrapper {
    flex-direction: column;
  }

  .BC-page_Installation.RunningSync
    > .Polaris-Card
    .BC-page_Installation--RunningSync
    .wrapper
    .left,
  .BC-page_Installation.RunningSync
    > .Polaris-Card
    .BC-page_Installation--RunningSync
    .wrapper
    .left
    img {
    max-width: 100%;
    border-radius: 8px 8px 0 0;
  }

  .BC-page_Installation.RunningSync
    > .Polaris-Card
    .BC-page_Installation--RunningSync
    .wrapper
    .left {
    margin-bottom: -10px;
  }

  .BC-page_Installation.RunningSync
    > .Polaris-Card
    .BC-page_Installation--RunningSync
    .wrapper
    .right {
    background: white;
    border-radius: 0 0 8px 8px;
  }
}

.BC-page_Installation.Survey > .Polaris-Card {
  max-width: 1120px;
  width: calc(100% - 20px * 2);
  margin: 20px auto;
}

.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey .wrapper {
  display: flex;
  align-items: stretch;
  height: 100%;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  padding: 40px 24px;
  padding-bottom: 20px;
}

.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey--Step2 .wrapper {
  padding-bottom: 0;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey--Step2
  .wrapper
  .select_feature_list
  .Polaris-ChoiceList__Title {
  margin-bottom: 10px;
}

body:has(* .BC-page_Installation.Survey)
  .Polaris-Combobox__Listbox
  .Polaris-Listbox-Option[aria-selected='true']
  .Polaris-Listbox-TextOption {
  background: #f2f7fe;
}

.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey .wrapper .top .title {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  color: #202223;
  margin-bottom: 10px;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .top
  .description {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #6d7175;
}

.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey .wrapper .content {
  margin: 20px 0;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step1 {
  display: flex;
  gap: 30px;
  width: 100%;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step1
  .Polaris-ChoiceList__Choices {
  display: flex;
  gap: 30px;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step1
  .Polaris-ChoiceList__ChoiceItem {
  background: #fafbfb;
  border: 2px solid #fafbfb;
  border-radius: 8px;
  padding: 25px 20px;
  padding-right: 5px;
}

.Polaris-Page-Header {
  padding-top: 2.5rem;
  padding-bottom: 0;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step1
  .Polaris-ChoiceList__ChoiceItem:has(input:checked) {
  border: 2px solid var(--p-interactive);
  background: white;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step1
  .Polaris-ChoiceList__ChoiceItem
  .Polaris-Choice {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step1
  .Polaris-ChoiceList__ChoiceItem
  .Polaris-Choice__Label {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #202223;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step1
  .Polaris-ChoiceList__ChoiceItem
  .option {
  padding-left: 27px;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step1
  .Polaris-ChoiceList__ChoiceItem
  .option
  .description {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #202223;
  margin-bottom: 20px;
  margin-top: 10px;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step1
  .Polaris-ChoiceList__ChoiceItem
  .Polaris-ChoiceList__ChoiceChildren {
  padding-left: 0;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step2 {
  width: 100%;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step2
  .Polaris-ChoiceList__Choices {
  display: flex;
  gap: 30px;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step2
  .multi-select {
  margin-top: 6px;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step2
  .multi-select
  .Polaris-TextField__VerticalContent {
  padding: 0;
  padding-left: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step2
  .multi-select
  .Polaris-TextField__Input {
  width: unset;
  display: inline-block;
  width: auto;
  cursor: pointer;
  min-width: 200px;
}

.BC-page_Installation.Survey
  > .Polaris-Card
  .BC-page_Installation--Survey
  .wrapper
  .content
  .step2
  .multi-select
  .Polaris-Tag {
  margin: 5px;
}

.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey--Step2 .action,
.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey--Step3 .action {
  border-top: 1px solid #ccc;
  padding: 10px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey--Step4 .wrapper {
  text-align: center;
}

@media (max-width: 768px) {
  .BC-page_Installation.Survey > .Polaris-Card {
    max-width: 520px;
    margin-bottom: 20px;
    border-radius: 8px;
  }

  .BC-page_Installation.Survey
    > .Polaris-Card
    .BC-page_Installation--Survey
    .wrapper
    .content
    .step1
    .Polaris-ChoiceList__Choices {
    flex-direction: column;
  }
}

.BC-page_Installation.Select-Theme > .Polaris-Card {
  max-width: 1152px;
  width: calc(100% - 20px * 2);
  margin: 0 auto;
  height: 600px;
}

.BC-page_Installation.Select-Theme .NewUser .title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 30px;
  margin-top: 0 !important;
}

.BC-page_Installation--Onboarding .BC-Shopify-Integration_Select-Theme-Form__Wrapper {
  margin-top: 24px;
}

.BC-page_Installation.Select-Theme .NewUser .form-error,
.BC-page_Installation.Select-Theme .NewUser .form-finish,
.BC-page_Installation.Select-Theme .NewUser .form-select-features,
.BC-page_Installation.Select-Theme .NewUser .form-select-theme {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px 40px;
  gap: 40px;
}

.BC-page_Installation--Onboarding .process {
  display: flex;
  width: 100%;
  background-color: #e4e4e4;
  height: 4px;
  border-radius: 8px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
}

.BC-page_Installation--Onboarding .process .active {
  background-color: #ff9f89;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.BC-page_Installation.Select-Theme .NewUser .form-select-features {
  gap: 24px;
  width: 100%;
}

.BC-page_Installation.Select-Theme .NewUser .form-select-theme .Polaris-Banner__Ribbon {
  padding-right: 12px;
}

.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form .desc {
  margin-bottom: 4px;
}

.BC-page_Installation .select-template-design .wrapper .form-select-templates {
  display: flex;
  width: 100%;
}

.BC-page_Installation .select-template-design .wrapper .content {
  padding: 80px 40px;
  gap: 24px;
  margin-top: 40px;
}

.BC-page_Installation .form-select-templates .list-templates {
  background: #f4f4f4;
}

.BC-page_Installation .form-select-templates > div {
  width: 50% !important;
}

.BC-page_Installation .form-select-templates ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  flex-wrap: wrap;
  column-gap: 59px;
  row-gap: 20px; /* Example vertical gap */
  padding: 40px 32px;
  justify-content: flex-start;
}

.BC-page_Installation .form-select-templates ul li {
  flex-basis: calc(50% - 29.5px);
  flex-shrink: 0;
  max-width: 220px;
}
.BC-page_Installation .form-select-templates .list-templates .item .template-name {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
}

.BC-page_Installation .form-select-templates .list-templates .item .template-name p {
  font-weight: 500;
  font-size: 14px;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal;
}

.BC-page_Installation
  .form-select-templates
  .list-templates
  .item
  .template-name
  .Polaris-Badge--statusInfo {
  color: #00527c;
  font-weight: 500;
}

.BC-page_Installation .form-select-templates .list-templates .item .description {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #6d7175;
}

.BC-page_Installation .form-select-templates .list-templates .item img {
  border-radius: 8px;
  object-fit: cover;
}

.BC-page_Installation .form-select-templates .list-templates .item img,
.BC-page_Installation .form-select-templates .list-templates .item .image {
  max-width: 220px;
  height: auto;
  max-height: 200px;
  width: 100%;
}

.BC-page_Installation .form-select-templates .list-templates .item .image {
  position: relative;
  overflow: hidden;
}

.BC-page_Installation .form-select-templates .list-templates .item-selected .image {
  border: 2px solid #2c6ecb;
  border-radius: 8px;
  border-top-right-radius: 10px;
}

.BC-page_Installation .form-select-templates .list-templates .item .image .selected {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 66;
  border-top-left-radius: 2px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 8px;
  padding: 6px 8px;
  background-color: #2c6ecb;
  color: white;
}

.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form__Wrapper {
  display: flex;
  align-items: center;
  column-gap: 8px;
  margin-bottom: 2px;
}

.BC-page_Installation.Select-Theme
  .NewUser
  .BC-Shopify-Integration_Select-Theme-Form__Wrapper
  .custom-select {
  flex-grow: 1;
  max-width: 450px;
}

.BC-page_Installation.Select-Theme
  .NewUser
  .BC-Shopify-Integration_Select-Theme-Form__Wrapper
  .checkbox-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BC-page_Installation.Select-Theme
  .NewUser
  .BC-Shopify-Integration_Select-Theme-Form__Wrapper
  .BC-Select-Integration__value-container {
  flex-wrap: nowrap;
}

.BC-page_Installation.Select-Theme .NewUser.select-theme-refresh {
  height: 20px;
  transition: all 0.4s;
  cursor: pointer;
}

.BC-page_Installation.Select-Theme .NewUser .select-theme-refresh.refreshing {
  -webkit-animation: spin 2s linear infinite;
  -moz-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form .btn-wrapper {
  margin-top: 24px;
  display: flex;
  gap: 12px;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel-root {
  height: 100%;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider {
  height: 100%;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .slider-wrapper {
  height: 100%;
}

.BC-page_Installation.Select-Theme
  .NewUser
  .preview
  .carousel.carousel-slider
  .slider-wrapper
  .slider {
  height: 100%;
}

.BC-page_Installation.Select-Theme
  .NewUser
  .preview
  .carousel.carousel-slider
  .slider-wrapper
  .slider
  .slide {
  height: 100%;
}

.BC-page_Installation.Select-Theme
  .NewUser
  .preview
  .carousel.carousel-slider
  .slider-wrapper
  .slider
  .slide
  > div {
  height: 100%;
}

.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .control-dots .dot {
  margin: 0 6px;
  width: 6px;
  height: 6px;
  background-color: #c9ccd0;
  opacity: 1;
}

.BC-page_Installation.Select-Theme
  .NewUser
  .preview
  .carousel.carousel-slider
  .control-dots
  .dot.selected {
  width: 10px;
  height: 10px;
  background-color: #ff3300;
}

.BC-page_Installation.Select-Theme .NewUser .finish-footer {
  display: flex;
  gap: 8px;
  margin-top: 24px;
}

.BC-page_Installation.Select-Theme img.loading2 {
  animation: rotation 2s infinite linear;
}

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}

/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.BC-page_Installation .dot-flashing {
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: #202223;
  color: #202223;
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.BC-page_Installation .dot-flashing::before,
.dot-flashing::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
}

.BC-page_Installation .dot-flashing::before {
  left: -14px;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: #202223;
  color: #202223;
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 0s;
}

.BC-page_Installation .dot-flashing::after {
  left: 14px;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: #202223;
  color: #202223;
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dot-flashing {
  0% {
    background-color: #202223;
  }

  50%,
  100% {
    background-color: rgba(152, 128, 255, 0.2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/installation.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;;;;;IAKE,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;;;;IAKE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;;;;;;IAME,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;;;;;;IAOE,0BAA0B;EAC5B;AACF;AACA;EACE;;;;;IAKE,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;;;;IAKE,2BAA2B;IAC3B,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;;IAEE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;;;;IAME,0BAA0B;EAC5B;AACF;;AAEA;GACG;IACC,2BAA2B;EAC7B;AACF;;AAEA;GACG;IACC,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;AACF;;;AAGA;EACE;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,wCAAwC;IACxC,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;;;IAGE,4BAA4B;IAC5B,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;;;;;;;;;;EAUE,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;AACf;AACA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;EAKE,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;;;;;EAKE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;;;;;;EAME,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;EAKE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;;;EAOE,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;;;;;;;;EAQE,WAAW;AACb;;AAEA;;;;;;EAME,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;EAME,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;;;;;;;EAOE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;;;;;;;;EAQE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;;;;EAQE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;;;;;;EAME,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;;;EAME,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;;EAOE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;;;;;;;;EAQE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;;;;;IAME,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;;;;;;IAME,aAAa;IACb,2BAA2B;EAC7B;AACF;;AAEA,oBAAoB;;AAEpB;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;EAKE,OAAO;EACP,WAAW;AACb;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;EAKE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;;;;;EAME,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;;;;;;EAOE,QAAQ;EACR,aAAa;AACf;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;;;EAME,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,sCAAsC;AACxC;;AAEA;;;;;;EAME,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;;;;EAME,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;;;;EAME,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;;;;;EAKE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;EAIE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;;;;IAIE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;;;;;EAOE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;EAOE,OAAO;AACT;;AAEA;;;;;;;EAOE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;;EAIE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;;EAOE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;;AAKA;;AAEA;EACE;;;;IAIE,sBAAsB;EACxB;;EAEA;;;;;IAKE,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;;;;;;IAME,WAAW;EACb;;EAEA;;;;;;;IAOE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;;;IAOE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;EAKE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;;;;EAIE,WAAW;EACX,OAAO;EACP,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,aAAa;EACb,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE;IACE;;mBAEe;IACf,gBAAgB;EAClB;;EAEA;IACE;;mBAEe;IACf,iBAAiB;EACnB;;EAEA;IACE;;kBAEc;IACd,iBAAiB;EACnB;;EAEA;IACE;;kBAEc;IACd,gBAAgB;EAClB;AACF;;AAEA;;;;;EAKE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;EAKE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;;;EAME,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;;;;;EAME,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;;;EAOE,sCAAsC;AACxC;;AAEA;;;;;;EAME,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;;EAME,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;;;;EAME,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;;;EAME,aAAa;EACb,8BAA8B;AAChC;;AAEA;;;;;;EAME,aAAa;EACb,QAAQ;AACV;;AAEA;;;;;;EAME,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;;;;EAKE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;;;;;;;;IAWE,eAAe;IACf,0BAA0B;EAC5B;;EAEA;;;;;IAKE,oBAAoB;EACtB;;EAEA;;;;;IAKE,iBAAiB;IACjB,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;;;;;;;EAOE,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;;EAOE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;;;;;;;;EAQE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;;;EAQE,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,eAAe;AACjB;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;;;EAOE,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;;;;;;;;EAQE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;;;;EAQE,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,WAAW;AACb;;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;;;;;;IAOE,sBAAsB;EACxB;AACF;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,aAAa,EAAE,yBAAyB;EACxC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;;;;EAME,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;EAIE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;;;;;;;EAOE,YAAY;AACd;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;EAIE;AACF;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,0CAA0C;EAC5C;AACF","sourcesContent":["/* START: Onboarding */\n.BC-page_Installation img {\n  image-rendering: pixelated;\n}\n\n.BC-page_Installation .ButtonCustom .Polaris-Button {\n  padding: 14px 30px;\n  height: 48px;\n  background: #ff3000;\n  box-shadow: 0px 4px 24px rgba(235, 69, 38, 0.4);\n  border-radius: 4px;\n  border: 0;\n  min-width: 110px;\n}\n\n.BC-page_Installation .ButtonCustom .Polaris-Button:hover {\n  background: #e82c00;\n}\n\n.BC-page_Installation .ButtonCustom .Polaris-Button .Polaris-Button__Text {\n  color: white;\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  font-family: 'Poppins', sans-serif;\n}\n\n.BC-page_Installation .ButtonCustom.disabled .Polaris-Button {\n  box-shadow: none;\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  cursor: not-allowed;\n}\n\n.BC-page_Installation .ButtonCustom.disabled .Polaris-Button .Polaris-Button__Text {\n  color: #8c9196;\n}\n\n.BC-page_Installation.Onboarding *,\n.BC-page_Installation.KYC *,\n.BC-page_Installation.SuccessInstall * {\n  font-family: 'Poppins', sans-serif;\n}\n\n.BC-page_Installation.Onboarding:has(.NewUser) * {\n  font-family: 'SF Pro Text';\n}\n\n.BC-page_Installation.Onboarding .NewUser .title {\n  font-family: 'SF Pro Display', 'Poppins';\n}\n\n.BC-page_Installation.Onboarding .NewUser .description {\n  font-family: 'SF Pro Text';\n}\n\n.BC-page_Installation.Onboarding .Polaris-Card {\n  max-width: 1120px;\n  width: calc(100% - 40px * 2);\n  margin: 0 auto;\n  max-height: 600px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding {\n  height: 100%;\n  max-height: 600px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding,\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper {\n  display: flex;\n  position: relative;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .control-dots {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper {\n  display: flex;\n  flex-direction: row-reverse;\n  border-radius: 10px;\n  max-height: 600px;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview,\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview img {\n  border-radius: 0 10px 10px 0;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre,\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {\n  position: absolute;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: white;\n  top: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre {\n  transform: translateY(-50%);\n  left: -22px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {\n  transform: translateY(-50%);\n  right: -22px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .select-feature {\n  max-height: 600px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview {\n  width: 50%;\n  max-width: 576px;\n  height: 100%;\n  flex-shrink: 0;\n  max-height: 600px;\n  overflow: hidden;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview img {\n  height: 100%;\n  margin-left: auto;\n  display: flex;\n  width: 100%;\n  max-width: 100%;\n  object-fit: cover;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content {\n  width: auto;\n  position: relative;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .form-select-theme {\n  width: 100%;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .form-onboarding-plan {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .form-email-opt {\n  padding: 80px 40px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content {\n  display: flex;\n  flex-direction: column;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content .features {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content .features > div {\n  display: flex;\n  gap: 8px;\n}\n\n@media (max-width: 1440px) {\n  .BC-page_Installation\n    .BC-page_Installation--Onboarding.NewUser\n    .wrapper\n    .content.form-email-opt\n    .subtitle {\n    margin-top: 32px !important;\n    font-size: 28px !important;\n    line-height: 30px !important;\n  }\n\n  .BC-page_Installation\n    .BC-page_Installation--Onboarding.NewUser\n    .wrapper\n    .content.form-email-opt\n    .title {\n    font-size: 36px !important;\n    line-height: 40px !important;\n  }\n\n  .BC-page_Installation.Select-Theme .NewUser .form-select-features {\n    padding: 24px !important;\n    gap: 16px !important;\n  }\n\n  .BC-page_Installation\n    .BC-page_Installation--Onboarding\n    .wrapper\n    .content\n    .onboarding-features\n    .feature-item {\n    height: 286px !important;\n  }\n\n  .BC-page_Installation .BC-page_Installation--Onboarding .form-select-features .title {\n    font-size: 24px !important;\n    line-height: 28px !important;\n  }\n\n  .BC-page_Installation\n    .BC-page_Installation--Onboarding\n    .wrapper\n    .content\n    .onboarding-features\n    .feature-item\n    .label {\n    font-size: 12px !important;\n  }\n}\n@media (max-width: 1280px) {\n  .BC-page_Installation\n    .BC-page_Installation--Onboarding.NewUser\n    .wrapper\n    .content.form-email-opt\n    .subtitle {\n    margin-top: 32px !important;\n    font-size: 22px !important;\n    line-height: 24px !important;\n  }\n\n  .BC-page_Installation\n    .BC-page_Installation--Onboarding.NewUser\n    .wrapper\n    .content.form-email-opt\n    .title {\n    font-size: 30px !important ;\n    line-height: 32px !important ;\n  }\n}\n\n@media (max-width: 1120px) {\n  .BC-page_Installation .form-select-templates .list-templates li {\n    width: 200px !important;\n    min-width: 200px !important;\n  }\n\n  .BC-page_Installation .form-select-templates .list-templates .item img,\n  .BC-page_Installation .form-select-templates .list-templates .item .image {\n    max-width: 200px !important;\n    max-height: 150px !important;\n  }\n\n  .BC-page_Installation .form-select-templates ul {\n    column-gap: 48px !important;\n  }\n\n  .BC-page_Installation\n    .form-select-templates\n    .list-templates\n    .item\n    .template-name\n    .Polaris-Badge--statusInfo {\n    min-width: 93px !important;\n  }\n}\n\n@media (max-width: 1112px) {\n   .BC-page_Installation .form-select-templates ul {\n    column-gap: 40px !important;\n  }\n}\n\n@media (max-width: 1096px) {\n   .BC-page_Installation .form-select-templates ul {\n    column-gap: 32px !important;\n  }\n}\n\n@media (max-width: 1080px) {\n  .BC-page_Installation .form-select-templates ul {\n    column-gap: 50px !important;\n  }\n\n  .BC-page_Installation .form-select-templates .list-templates li {\n    width: 150px !important;\n    min-width: 150px !important;\n  }\n\n  .BC-page_Installation .form-select-templates .list-templates .item .image>di:nth-child(1) {\n    min-width: 150px !important;\n    height: 150px !important;\n  }\n}\n\n\n@media (max-width: 1024px) {\n  .BC-page_Installation .Polaris-Card {\n    width: 560px;\n    max-width: 560px !important;\n  }\n\n  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper {\n    flex-direction: column;\n  }\n\n  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-pre,\n  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .btn-next {\n    top: 75%;\n    z-index: 10;\n  }\n\n  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview img {\n    border-radius: 10px 10px 0 0;\n  }\n\n  .BC-page_Installation .select-template-design .wrapper .form-select-templates {\n    flex-direction: column;\n  }\n\n  .BC-page_Installation .select-template-design .wrapper .form-select-templates > div {\n    width: 100% !important;\n  }\n\n  .BC-page_Installation.Onboarding.NewUser .Polaris-Card {\n    width: 560px;\n  }\n\n  .BC-page_Installation .form-select-templates .list-templates li {\n    width: 150px !important;\n  }\n\n  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper {\n    flex-direction: column;\n  }\n\n  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .btn-pre,\n  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .btn-next {\n    top: 75%;\n    z-index: 10;\n  }\n\n  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview {\n    width: 100%;\n  }\n\n  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .preview img {\n    border-radius: 10px 10px 0 0;\n  }\n\n  .BC-page_Installation .BC-page_Installation--Onboarding.NewUser .wrapper .content {\n    background: white;\n    border-radius: 0 0 10px 10px;\n  }\n}\n\n@media (max-height: 620px) {\n  .BC-page_Installation.Select-Theme > .Polaris-Card {\n    max-height: calc(100% - 48px) !important;\n    height: 550px !important;\n  }\n  .BC-page_Installation .wrapper .preview {\n    height: 550px !important;\n  }\n  .BC-page_Installation.Select-Theme .NewUser .form-select-theme {\n    padding: 60px 40px !important;\n    max-height: 600px !important;\n  }\n  .BC-page_Installation .select-theme-simplify-running .preview {\n    height: 100% !important;\n  }\n  .BC-page_Installation.Select-Theme .NewUser .form-select-theme {\n    gap: 10px !important;\n  }\n  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .title {\n    font-size: 26px !important;\n  }\n  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .desc {\n    font-size: 12px !important;\n  }\n\n  .BC-page_Installation .form-select-templates .list-templates .Polaris-Scrollable {\n    max-height: 500px !important;\n  }\n}\n\n@media (max-height: 550px) {\n  .BC-page_Installation.Select-Theme > .Polaris-Card,\n  .BC-page_Installation,\n  .BC-page_Installation .wrapper .preview {\n    max-height: 500px !important;\n    height: 500px !important;\n  }\n  .BC-page_Installation.Select-Theme .NewUser .form-select-theme {\n    padding: 60px 40px !important;\n    max-height: 500px !important;\n  }\n  .BC-page_Installation .select-theme-simplify-running .preview {\n    height: 100% !important;\n  }\n  .BC-page_Installation.Select-Theme .NewUser .form-select-theme {\n    gap: 10px !important;\n  }\n  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .title {\n    font-size: 26px !important;\n  }\n  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .desc {\n    font-size: 12px !important;\n  }\n}\n\n.BC-page_Installation {\n  padding: 24px;\n}\n\n@media (max-height: 490px) {\n  .BC-page_Installation.Select-Theme .NewUser .installing {\n    gap: 20px !important;\n  }\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-email-opt\n  .title,\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-onboarding-plan\n  .title {\n  text-align: left;\n  font-family: 'SF Pro Display', sans-serif;\n  font-size: 42px;\n  font-weight: 700;\n  line-height: 44px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-onboarding-plan\n  .title {\n  margin-top: 0;\n}\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-email-opt\n  .subtitle {\n  margin-top: 64px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-email-opt\n  .subtitle,\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-onboarding-plan\n  .subtitle {\n  text-align: left;\n  margin-bottom: 8px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 30px;\n  font-weight: 600;\n  line-height: 40px;\n}\n\n.BC-page_Installation.Onboarding form .Polaris-FormLayout__Item {\n  padding-top: 8px;\n  margin-top: unset;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-email-opt\n  .desc {\n  text-align: left;\n  font-family: 'SF Pro Text', sans-serif;\n  line-height: 20px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-onboarding-plan\n  .desc {\n  text-align: left;\n  margin-bottom: 24px;\n  font-family: 'SF Pro Text', sans-serif;\n  line-height: 20px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-email-opt\n  .Polaris-Label\n  .Polaris-Label__Text {\n  margin-bottom: 5px;\n  font-weight: 400 !important;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-email-opt\n  .Polaris-FormLayout\n  input {\n  min-height: 2.375rem;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-email-opt\n  .Polaris-InlineError\n  .Polaris-InlineError__Icon {\n  display: block;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-email-opt\n  .menu {\n  position: static;\n  display: block;\n  margin-top: 25px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding.NewUser\n  .wrapper\n  .content.form-onboarding-plan\n  .menu {\n  position: static;\n  display: block;\n  margin: 0;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .skip {\n  text-align: right;\n  font-weight: 400;\n  font-size: 14px;\n  color: #6d7175;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .skip span {\n  cursor: pointer;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .badge {\n  max-width: fit-content;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0px;\n  text-align: center;\n  border: 1px solid #eaecf0;\n  border-radius: 16px;\n  color: #344054;\n  background: #f9fafb;\n  padding: 2px 8px;\n  margin-bottom: 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .title {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n  color: #202223;\n  display: flex;\n  align-items: baseline;\n  gap: 18px;\n  margin-bottom: 8px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .description {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  color: #202223;\n  margin-top: 24px;\n  padding: 0 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .description.step-5 {\n  font-size: 30px;\n  line-height: 40px;\n  margin-top: 0px;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .step {\n  margin-top: 150px;\n  position: absolute;\n  bottom: 200px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step,\n.render-choice-2 .Polaris-ChoiceList__Choices li {\n  display: flex;\n  align-items: center;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step {\n  justify-content: center;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step .item {\n  width: 6px;\n  height: 6px;\n  background: #c9ccd0;\n  margin: 3px;\n  border-radius: 50%;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .Step .active {\n  width: 10px;\n  height: 10px;\n  background: #ff3300;\n  border-radius: 50%;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  margin-top: 50px;\n  bottom: 100px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .menu .back {\n  display: flex;\n  position: absolute;\n  left: 45px;\n  align-items: center;\n  cursor: pointer;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding\n  .wrapper\n  .content\n  .menu\n  .back\n  .Polaris-Icon {\n  width: 12px;\n  height: unset;\n  margin: 10px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding\n  .wrapper\n  .content\n  .menu\n  .back\n  .Polaris-Icon\n  svg {\n  fill: black;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding\n  .wrapper\n  .content\n  .onboarding-features\n  .list {\n  display: flex;\n  gap: 16px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding\n  .wrapper\n  .content\n  .onboarding-features\n  .feature-item {\n  gap: 8px;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  background: #fff6f2;\n  cursor: pointer;\n  width: calc(100% / 4 - 8px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  max-height: 305px;\n  height: 305px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding\n  .wrapper\n  .content\n  .onboarding-features\n  .feature-item\n  .label {\n  display: flex;\n  align-items: start;\n  padding: 20px;\n  font-size: 14px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding\n  .wrapper\n  .content\n  .onboarding-features\n  .feature-item\n  .label\n  .Polaris-Checkbox__Icon {\n  background-color: #ff3000;\n  border-radius: 6px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--Onboarding\n  .wrapper\n  .content\n  .onboarding-features\n  .feature-item\n  .desc {\n  color: #6d7175;\n}\n\n.BC-page_Installation .BC-page_Installation--Onboarding .wrapper .content .onboarding-features img {\n  width: 100%;\n  height: auto;\n  position: absolute;\n  z-index: 5px;\n  bottom: 0;\n}\n\n.BC-page_Installation.KYC,\n.BC-page_Installation.SuccessInstall {\n  padding-bottom: 30px;\n}\n\n.BC-page_Installation.KYC .Polaris-Card,\n.BC-page_Installation.SuccessInstall .Polaris-Card {\n  max-width: 1160px;\n  width: calc(100% - 20px * 2);\n  margin: 20px auto;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper {\n  display: flex;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content {\n  flex: 1;\n  padding: 40px 56px;\n  position: relative;\n  min-height: 600px;\n  display: flex;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm {\n  height: auto;\n  position: relative;\n  width: 100%;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .title {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 30px;\n  color: #202223;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .description {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #6d7175;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8c9196;\n  margin-top: 40px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-title {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 40px;\n  color: #202223;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-description {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #6d7175;\n  margin-top: 8px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm .step-form {\n  margin-top: 40px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  position: relative;\n  margin-top: 50px;\n  bottom: 0;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back {\n  display: flex;\n  position: absolute;\n  left: 0;\n  align-items: center;\n  cursor: pointer;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back .Polaris-Icon {\n  width: 12px;\n  height: unset;\n  margin: 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .content .menu .back .Polaris-Icon svg {\n  fill: black;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .preview {\n  width: 440px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .wrapper .preview img {\n  width: 440px;\n  height: 100%;\n  font-size: 0;\n  line-height: 0;\n  display: block;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin {\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-gap: 16px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item {\n  min-height: 166px;\n  width: 296px;\n  position: relative;\n  padding: 20px 12px 20px 20px;\n  border: 2px solid #fafbfb;\n  border-radius: 8px;\n  background: #fafbfb;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item:hover {\n  background: #fff8f6;\n  cursor: pointer;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--KYC\n  .SelectPlugin\n  .SelectPlugin__Item:hover\n  ~ .BC-page_Installation\n  .BC-page_Installation--KYC\n  .wrapper\n  .preview {\n  border: 4px solid red;\n  border-color: var(--hover);\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .Polaris-Choice {\n  position: absolute;\n  right: 12px;\n  top: 12px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--KYC\n  .SelectPlugin\n  .SelectPlugin__Item\n  .Polaris-Choice\n  .Polaris-Checkbox__Backdrop {\n  border: 1px solid #c9cccf;\n  border-radius: 4px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--KYC\n  .SelectPlugin\n  .SelectPlugin__Item\n  .Polaris-Choice\n  .Polaris-Checkbox__Backdrop::before {\n  background-color: #ff3000;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--KYC\n  .SelectPlugin\n  .SelectPlugin__Item\n  .Polaris-Choice\n  .Polaris-Choice__Control {\n  margin-right: 0;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .icon {\n  width: 24px;\n  height: 24px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .title {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: #202223;\n  margin-top: 8px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item .description {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #6d7175;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item--Selected,\n.BC-page_Installation .BC-page_Installation--KYC .SelectPlugin .SelectPlugin__Item--Selected:hover {\n  border: 2px solid #ff8366;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectKind {\n  margin-bottom: 20px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField__Input {\n  min-height: 56px;\n  border: px solid #a1a3ad;\n  border-radius: 8px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField {\n  --p-focused: white;\n  /* --p-focused: #FF3000; */\n  border-radius: 10px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--KYC\n  .SelectKind\n  .Polaris-TextField--focus\n  .Polaris-TextField__Input {\n  border: 2px solid #ff3000;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .SelectKind .Polaris-TextField__Backdrop {\n  border-radius: 8px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .IndustryList {\n  padding: 2px;\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 10px;\n  row-gap: 10px;\n  gap: 10px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .IndustryItem {\n  padding: 6px 8px;\n  background: #f1f2f3;\n  border-radius: 4px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .IndustryItem:not(.IndustryItem__Selected) {\n  cursor: pointer;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .IndustryItem__Selected {\n  background: #ffefeb;\n  color: #ff3000;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper {\n  display: flex;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content {\n  flex: 1;\n  min-height: 600px;\n  position: relative;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content {\n  max-width: 540px;\n  color: #202223;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: calc(100% - 80px);\n  transform: translate(-50%, -50%);\n}\n\n.BC-page_Installation\n  .BC-page_Installation--SuccessInstall\n  .wrapper\n  .content\n  .inner-content\n  .title {\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 40px;\n  margin-bottom: 35px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--SuccessInstall\n  .wrapper\n  .content\n  .inner-content\n  .description,\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .inner-content .list {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 20px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--SuccessInstall\n  .wrapper\n  .content\n  .inner-content\n  .description {\n  margin-bottom: 16px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--SuccessInstall\n  .wrapper\n  .content\n  .inner-content\n  .list\n  .item {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--SuccessInstall\n  .wrapper\n  .content\n  .inner-content\n  .list\n  img {\n  margin-top: 4px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--SuccessInstall\n  .wrapper\n  .content\n  .inner-content\n  .list\n  .title2 {\n  font-weight: 600;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--SuccessInstall\n  .wrapper\n  .content\n  .inner-content\n  .action {\n  display: flex;\n  gap: 10px;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--SuccessInstall\n  .wrapper\n  .content\n  .inner-content\n  .action\n  > .Polaris-Button {\n  border: 1px solid #292929;\n  box-shadow: 0px 4px 24px 0px #eb452633;\n}\n\n.BC-page_Installation\n  .BC-page_Installation--SuccessInstall\n  .wrapper\n  .content\n  .inner-content\n  .action\n  > .Polaris-Button\n  .Polaris-Button__Text {\n  text-transform: uppercase;\n  color: #292929;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview {\n  width: 540px;\n}\n\n.BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview img {\n  width: 540px;\n  height: 100%;\n  font-size: 0;\n  line-height: 0;\n  display: block;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .IndustryList {\n  margin-top: 20px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .step4 {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .step4-content .ButtonCustom {\n  margin-top: 30px;\n}\n\n.BC-page_Installation .BC-page_Installation--KYC .step4-content .ButtonCustom .Polaris-Button {\n  padding: 14px 20px;\n}\n\n@media (max-width: 1024px) {\n  .BC-page_Installation.KYC .Polaris-Card,\n  .BC-page_Installation.SuccessInstall .Polaris-Card {\n    width: 560px;\n  }\n  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview {\n    height: auto;\n  }\n\n  .BC-page_Installation .BC-page_Installation--Onboarding .wrapper .preview img {\n    width: 100%;\n  }\n\n  .BC-page_Installation .BC-page_Installation--KYC .wrapper {\n    flex-direction: column;\n  }\n\n  .BC-page_Installation .BC-page_Installation--KYC .wrapper .content {\n    width: 100%;\n    background: white;\n    border-radius: 10px 10px 0 0;\n  }\n\n  .BC-page_Installation .BC-page_Installation--KYC .wrapper .preview {\n    width: 100%;\n    margin-top: -20px;\n  }\n\n  .BC-page_Installation .BC-page_Installation--KYC .wrapper .preview img {\n    width: 100%;\n    border-radius: 0 0 10px 10px;\n  }\n\n  .BC-page_Installation .BC-page_Installation--KYC .wrapper .content .StepForm {\n    padding-bottom: 50px;\n  }\n\n  .BC-page_Installation .BC-page_Installation--KYC .SelectPlugin {\n    justify-content: center;\n    grid-template-columns: auto;\n  }\n\n  .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper {\n    flex-direction: column;\n  }\n\n  .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content {\n    width: 100%;\n    background: white;\n    border-radius: 10px 10px 0 0;\n  }\n\n  .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview {\n    width: 100%;\n    margin-top: -20px;\n  }\n\n  .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .preview img {\n    width: 100%;\n    border-radius: 0 0 10px 10px;\n  }\n\n  .BC-page_Installation .BC-page_Installation--SuccessInstall .wrapper .content .StepForm {\n    padding-bottom: 50px;\n  }\n\n  .BC-page_Installation\n    .BC-page_Installation--Onboarding\n    .wrapper\n    .content\n    .onboarding-features\n    .list {\n    flex-wrap: wrap !important;\n    gap: 12px !important;\n  }\n\n  .BC-page_Installation\n    .BC-page_Installation--Onboarding\n    .wrapper\n    .content\n    .onboarding-features\n    .feature-item {\n    height: 300px;\n    width: calc(100% / 2 - 8px);\n  }\n}\n\n/* END: Onboarding */\n\n.BC-page_Installation.ChooseTheme > .Polaris-Card {\n  max-width: 1120px;\n  width: calc(100% - 20px * 2);\n  margin: 20px auto;\n}\n\n.BC-page_Installation.ChooseTheme > .Polaris-Card .BC-page_Installation--ChooseTheme .content-top {\n  display: flex;\n  padding: 30px 24px;\n  align-items: center;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .info {\n  flex: 1;\n  width: auto;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .info\n  .title {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n  color: #202223;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .info\n  .description {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #202223;\n  margin-top: 12px;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .sync-info {\n  width: 400px;\n  padding-left: 20px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .sync-info\n  .card {\n  width: 349px;\n  height: 108px;\n  background: #fafbfb;\n  border-radius: 8px;\n  padding: 16px 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .sync-info\n  .card\n  .est {\n  gap: 5px;\n  display: flex;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .sync-info\n  .card\n  .percent {\n  font-weight: 600;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .sync-info\n  .title {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  font-weight: bold;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .sync-info\n  .title\n  img.loading {\n  animation: rotation 2s infinite linear;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .sync-info\n  .progress {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .sync-info\n  .progressing {\n  width: 250px;\n  height: 8px;\n  background: #e4e5e7;\n  border-radius: 4px;\n  display: inline-block;\n  overflow: hidden;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-top\n  .sync-info\n  .progressing::before {\n  width: var(--size);\n  height: 8px;\n  display: block;\n  content: '';\n  background: #008060;\n}\n\n.BC-page_Installation.ChooseTheme > .Polaris-Card .BC-page_Installation--ChooseTheme .content-main {\n  border-bottom: 1px solid #e1e3e5;\n  border-top: 1px solid #e1e3e5;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-main\n  .Polaris-Card {\n  border-radius: 0;\n  box-shadow: unset;\n  outline: unset;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-main\n  .Polaris-Card\n  .Polaris-Card__Section {\n  padding-bottom: 0;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .Polaris-ChoiceList {\n  padding-bottom: 12px;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .Polaris-ChoiceList__ChoiceItem {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n@media (max-width: 40em) {\n  .BC-page_Installation.ChooseTheme\n    > .Polaris-Card\n    .BC-page_Installation--ChooseTheme\n    .Polaris-ChoiceList__ChoiceChildren {\n    margin-top: 0;\n  }\n}\n\n.BC-page_Installation.ChooseTheme .select-theme > div {\n  width: 480px;\n}\n\n.BC-page_Installation.ChooseTheme .select-theme {\n  width: 520px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-page_Installation.ChooseTheme .select-theme-warning {\n  margin-top: 12px;\n  color: #916a00;\n}\n\n.BC-page_Installation.ChooseTheme .select-theme > div {\n  width: 480px;\n}\n\n.BC-page_Installation.ChooseTheme .feature-installed-info {\n  color: #008060;\n  margin-bottom: 10px;\n}\n\n.BC-page_Installation.ChooseTheme .title {\n  padding-bottom: 0.5625rem;\n}\n\n.BC-page_Installation.ChooseTheme .list-features-select > div {\n  margin-bottom: 12px;\n}\n\n.BC-page_Installation.ChooseTheme .select-recommedation-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 15px;\n  margin-top: -15px;\n}\n\n.BC-page_Installation.ChooseTheme .BC-Theme-Setup_Form-Item {\n  margin-bottom: var(--p-space-5);\n}\n\n.BC-page_Installation.ChooseTheme .Polaris-ChoiceList__ChoiceChildren {\n  display: inline-block;\n  vertical-align: top;\n  padding-left: 0.625rem;\n}\n\n.BC-page_Installation.ChooseTheme .select-recommedation-wrapper div:nth-child(2) {\n  width: 356px;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets {\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  margin-bottom: 10px;\n  min-height: 222px;\n  padding: 17px;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading {\n  font-weight: bold;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading,\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .row {\n  display: flex;\n  padding: 12px 0;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .data {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(1),\n.BC-page_Installation.ChooseTheme\n  .ListRecommendationWidgets\n  .wrapper\n  .content\n  .row\n  div:nth-child(1) {\n  width: 30px;\n  display: flex;\n  align-items: flex-start;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(2),\n.BC-page_Installation.ChooseTheme\n  .ListRecommendationWidgets\n  .wrapper\n  .content\n  .row\n  div:nth-child(2) {\n  width: 220px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(3),\n.BC-page_Installation.ChooseTheme\n  .ListRecommendationWidgets\n  .wrapper\n  .content\n  .row\n  div:nth-child(3) {\n  flex: 1;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(4),\n.BC-page_Installation.ChooseTheme\n  .ListRecommendationWidgets\n  .wrapper\n  .content\n  .row\n  div:nth-child(4) {\n  width: 230px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.BC-page_Installation.ChooseTheme\n  .ListRecommendationWidgets\n  .wrapper\n  .content\n  .row\n  div:nth-child(4)\n  img {\n  cursor: pointer;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .data {\n  height: 100%;\n}\n\n.BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .content .empty {\n  height: 190px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.BC-page_Installation.ChooseTheme .select-recommedation-widget .add-widget-action {\n  text-align: right;\n}\n\n.BC-page_Installation.ChooseTheme .select-recommedation-widget .add-widget-action p {\n  color: #2c6ecb;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.select-theme-refresh {\n  height: 20px;\n}\n\n.BC-page_Installation.ChooseTheme .select-theme-refresh.refreshing {\n  animation: rotation 2s infinite linear;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-bottom {\n  display: flex;\n  padding: 10px 24px;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 0 0 0.5rem 0.5rem;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-bottom\n  .description {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #6d7175;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-bottom\n  .description\n  i\n  .Polaris-Link {\n  text-decoration: none;\n  color: #6d7175;\n}\n\n.BC-page_Installation.ChooseTheme\n  > .Polaris-Card\n  .BC-page_Installation--ChooseTheme\n  .content-bottom\n  .action {\n}\n\n@media (max-width: 768px) {\n  .BC-page_Installation.ChooseTheme\n    > .Polaris-Card\n    .BC-page_Installation--ChooseTheme\n    .content-top {\n    flex-direction: column;\n  }\n\n  .BC-page_Installation.ChooseTheme\n    > .Polaris-Card\n    .BC-page_Installation--ChooseTheme\n    .content-top\n    .sync-info {\n    padding: 20px 0;\n    width: 100%;\n    padding-bottom: 0;\n  }\n\n  .BC-page_Installation.ChooseTheme\n    > .Polaris-Card\n    .BC-page_Installation--ChooseTheme\n    .content-top\n    .sync-info\n    .card {\n    width: 100%;\n  }\n\n  .BC-page_Installation.ChooseTheme\n    > .Polaris-Card\n    .BC-page_Installation--ChooseTheme\n    .content-top\n    .sync-info\n    .card\n    .progressing {\n    width: calc(100% - 45px);\n  }\n\n  .BC-page_Installation.ChooseTheme .select-theme {\n    width: calc(100% - 20px);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .BC-page_Installation.ChooseTheme .select-theme > div {\n    width: 100%;\n  }\n\n  .BC-page_Installation.ChooseTheme .ListRecommendationWidgets {\n    overflow-x: auto;\n  }\n\n  .BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper {\n    min-width: 800px;\n  }\n\n  .BC-page_Installation.ChooseTheme .ListRecommendationWidgets .wrapper .heading div:nth-child(3),\n  .BC-page_Installation.ChooseTheme\n    .ListRecommendationWidgets\n    .wrapper\n    .content\n    .row\n    div:nth-child(3) {\n    min-width: 200px;\n  }\n}\n\n.BC-page_Installation.RunningSync > .Polaris-Card {\n  max-width: 1120px;\n  width: calc(100% - 20px * 2);\n  margin: 20px auto;\n}\n\n.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .wrapper {\n  display: flex;\n  align-items: stretch;\n}\n\n.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .left {\n  width: 520px;\n  height: 708px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .left\n  .left-img {\n  width: 640px;\n  height: 640px;\n  z-index: 999;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .left\n  .left-img\n  img {\n  width: 100%;\n}\n\n.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .left img {\n  line-height: 0;\n  font-size: 0;\n  display: block;\n}\n\n.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .right {\n  width: auto;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .contact-us {\n  position: absolute;\n  bottom: 40px;\n  left: 32px;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right-content {\n  width: auto;\n  flex: 1;\n  padding: 32px;\n  min-height: 440px;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right-content.skeleton {\n  display: flex;\n  align-items: center;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right-content\n  .skeleton {\n  height: 200px;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right-content.has-inner {\n  display: flex;\n  align-items: center;\n}\n\n.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .right .title {\n  font-size: 28px;\n  line-height: 32px;\n  color: #202223;\n  margin-bottom: 10px;\n  font-weight: 600;\n  display: flex;\n}\n\n.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .dots {\n  width: 30px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding-bottom: 4px;\n}\n\n.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .dots-3 {\n  width: 5px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  animation: d3 1s infinite linear alternate;\n}\n\n@keyframes d3 {\n  0% {\n    box-shadow:\n      10px 0 #000,\n      -10px 0 #0002;\n    background: #000;\n  }\n\n  33% {\n    box-shadow:\n      10px 0 #000,\n      -10px 0 #0002;\n    background: #0002;\n  }\n\n  66% {\n    box-shadow:\n      10px 0 #0002,\n      -10px 0 #000;\n    background: #0002;\n  }\n\n  100% {\n    box-shadow:\n      10px 0 #0002,\n      -10px 0 #000;\n    background: #000;\n  }\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .description {\n  font-size: 14px;\n  line-height: 20px;\n  color: #202223;\n  margin-bottom: 10px;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info\n  .card {\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info\n  .title {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  font-size: 16px;\n  line-height: 24px;\n  color: #202223;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info\n  .title\n  span.refresh {\n  display: inline-block;\n  width: 18px;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info\n  .title\n  img.loading {\n  animation: rotation 2s infinite linear;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info\n  .progress {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info\n  .progressing {\n  height: 8px;\n  width: 100%;\n  background: #e4e5e7;\n  border-radius: 4px;\n  display: inline-block;\n  overflow: hidden;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info\n  .progressing::before {\n  width: var(--size);\n  height: 8px;\n  display: block;\n  content: '';\n  background: #008060;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info\n  .est {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info\n  .est-wrap {\n  display: flex;\n  gap: 5px;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info\n  .est-text {\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  color: #6d7175;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .sync-info\n  .est\n  .percent {\n  font-weight: 500;\n  font-size: 14px;\n  color: #202223;\n}\n\n.BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .right .line {\n  margin: 35px 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #e1e3e5;\n}\n\n.BC-page_Installation.RunningSync\n  > .Polaris-Card\n  .BC-page_Installation--RunningSync\n  .right\n  .Polaris-Button {\n  margin-top: 15px;\n  margin-right: 10px;\n}\n\n@media (max-width: 768px) {\n  .BC-page_Installation.RunningSync > .Polaris-Card {\n    max-width: 520px;\n    margin-bottom: 20px;\n    border-radius: 8px;\n  }\n\n  .BC-page_Installation.RunningSync > .Polaris-Card .BC-page_Installation--RunningSync .wrapper {\n    flex-direction: column;\n  }\n\n  .BC-page_Installation.RunningSync\n    > .Polaris-Card\n    .BC-page_Installation--RunningSync\n    .wrapper\n    .left,\n  .BC-page_Installation.RunningSync\n    > .Polaris-Card\n    .BC-page_Installation--RunningSync\n    .wrapper\n    .left\n    img {\n    max-width: 100%;\n    border-radius: 8px 8px 0 0;\n  }\n\n  .BC-page_Installation.RunningSync\n    > .Polaris-Card\n    .BC-page_Installation--RunningSync\n    .wrapper\n    .left {\n    margin-bottom: -10px;\n  }\n\n  .BC-page_Installation.RunningSync\n    > .Polaris-Card\n    .BC-page_Installation--RunningSync\n    .wrapper\n    .right {\n    background: white;\n    border-radius: 0 0 8px 8px;\n  }\n}\n\n.BC-page_Installation.Survey > .Polaris-Card {\n  max-width: 1120px;\n  width: calc(100% - 20px * 2);\n  margin: 20px auto;\n}\n\n.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey .wrapper {\n  display: flex;\n  align-items: stretch;\n  height: 100%;\n  min-height: 180px;\n  display: flex;\n  flex-direction: column;\n  padding: 40px 24px;\n  padding-bottom: 20px;\n}\n\n.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey--Step2 .wrapper {\n  padding-bottom: 0;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey--Step2\n  .wrapper\n  .select_feature_list\n  .Polaris-ChoiceList__Title {\n  margin-bottom: 10px;\n}\n\nbody:has(* .BC-page_Installation.Survey)\n  .Polaris-Combobox__Listbox\n  .Polaris-Listbox-Option[aria-selected='true']\n  .Polaris-Listbox-TextOption {\n  background: #f2f7fe;\n}\n\n.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey .wrapper .top .title {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n  color: #202223;\n  margin-bottom: 10px;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .top\n  .description {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #6d7175;\n}\n\n.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey .wrapper .content {\n  margin: 20px 0;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step1 {\n  display: flex;\n  gap: 30px;\n  width: 100%;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step1\n  .Polaris-ChoiceList__Choices {\n  display: flex;\n  gap: 30px;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step1\n  .Polaris-ChoiceList__ChoiceItem {\n  background: #fafbfb;\n  border: 2px solid #fafbfb;\n  border-radius: 8px;\n  padding: 25px 20px;\n  padding-right: 5px;\n}\n\n.Polaris-Page-Header {\n  padding-top: 2.5rem;\n  padding-bottom: 0;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step1\n  .Polaris-ChoiceList__ChoiceItem:has(input:checked) {\n  border: 2px solid var(--p-interactive);\n  background: white;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step1\n  .Polaris-ChoiceList__ChoiceItem\n  .Polaris-Choice {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step1\n  .Polaris-ChoiceList__ChoiceItem\n  .Polaris-Choice__Label {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  color: #202223;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step1\n  .Polaris-ChoiceList__ChoiceItem\n  .option {\n  padding-left: 27px;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step1\n  .Polaris-ChoiceList__ChoiceItem\n  .option\n  .description {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #202223;\n  margin-bottom: 20px;\n  margin-top: 10px;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step1\n  .Polaris-ChoiceList__ChoiceItem\n  .Polaris-ChoiceList__ChoiceChildren {\n  padding-left: 0;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step2 {\n  width: 100%;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step2\n  .Polaris-ChoiceList__Choices {\n  display: flex;\n  gap: 30px;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step2\n  .multi-select {\n  margin-top: 6px;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step2\n  .multi-select\n  .Polaris-TextField__VerticalContent {\n  padding: 0;\n  padding-left: 10px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  overflow: auto;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step2\n  .multi-select\n  .Polaris-TextField__Input {\n  width: unset;\n  display: inline-block;\n  width: auto;\n  cursor: pointer;\n  min-width: 200px;\n}\n\n.BC-page_Installation.Survey\n  > .Polaris-Card\n  .BC-page_Installation--Survey\n  .wrapper\n  .content\n  .step2\n  .multi-select\n  .Polaris-Tag {\n  margin: 5px;\n}\n\n.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey--Step2 .action,\n.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey--Step3 .action {\n  border-top: 1px solid #ccc;\n  padding: 10px 24px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.BC-page_Installation.Survey > .Polaris-Card .BC-page_Installation--Survey--Step4 .wrapper {\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .BC-page_Installation.Survey > .Polaris-Card {\n    max-width: 520px;\n    margin-bottom: 20px;\n    border-radius: 8px;\n  }\n\n  .BC-page_Installation.Survey\n    > .Polaris-Card\n    .BC-page_Installation--Survey\n    .wrapper\n    .content\n    .step1\n    .Polaris-ChoiceList__Choices {\n    flex-direction: column;\n  }\n}\n\n.BC-page_Installation.Select-Theme > .Polaris-Card {\n  max-width: 1152px;\n  width: calc(100% - 20px * 2);\n  margin: 0 auto;\n  height: 600px;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .title {\n  font-family: 'Poppins', sans-serif;\n  font-weight: 600;\n  font-size: 30px;\n  margin-top: 0 !important;\n}\n\n.BC-page_Installation--Onboarding .BC-Shopify-Integration_Select-Theme-Form__Wrapper {\n  margin-top: 24px;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .form-error,\n.BC-page_Installation.Select-Theme .NewUser .form-finish,\n.BC-page_Installation.Select-Theme .NewUser .form-select-features,\n.BC-page_Installation.Select-Theme .NewUser .form-select-theme {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 80px 40px;\n  gap: 40px;\n}\n\n.BC-page_Installation--Onboarding .process {\n  display: flex;\n  width: 100%;\n  background-color: #e4e4e4;\n  height: 4px;\n  border-radius: 8px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 20;\n}\n\n.BC-page_Installation--Onboarding .process .active {\n  background-color: #ff9f89;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .form-select-features {\n  gap: 24px;\n  width: 100%;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .form-select-theme .Polaris-Banner__Ribbon {\n  padding-right: 12px;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form .desc {\n  margin-bottom: 4px;\n}\n\n.BC-page_Installation .select-template-design .wrapper .form-select-templates {\n  display: flex;\n  width: 100%;\n}\n\n.BC-page_Installation .select-template-design .wrapper .content {\n  padding: 80px 40px;\n  gap: 24px;\n  margin-top: 40px;\n}\n\n.BC-page_Installation .form-select-templates .list-templates {\n  background: #f4f4f4;\n}\n\n.BC-page_Installation .form-select-templates > div {\n  width: 50% !important;\n}\n\n.BC-page_Installation .form-select-templates ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  flex-wrap: wrap;\n  column-gap: 59px;\n  row-gap: 20px; /* Example vertical gap */\n  padding: 40px 32px;\n  justify-content: flex-start;\n}\n\n.BC-page_Installation .form-select-templates ul li {\n  flex-basis: calc(50% - 29.5px);\n  flex-shrink: 0;\n  max-width: 220px;\n}\n.BC-page_Installation .form-select-templates .list-templates .item .template-name {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 12px;\n}\n\n.BC-page_Installation .form-select-templates .list-templates .item .template-name p {\n  font-weight: 500;\n  font-size: 14px;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  white-space: normal;\n}\n\n.BC-page_Installation\n  .form-select-templates\n  .list-templates\n  .item\n  .template-name\n  .Polaris-Badge--statusInfo {\n  color: #00527c;\n  font-weight: 500;\n}\n\n.BC-page_Installation .form-select-templates .list-templates .item .description {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #6d7175;\n}\n\n.BC-page_Installation .form-select-templates .list-templates .item img {\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.BC-page_Installation .form-select-templates .list-templates .item img,\n.BC-page_Installation .form-select-templates .list-templates .item .image {\n  max-width: 220px;\n  height: auto;\n  max-height: 200px;\n  width: 100%;\n}\n\n.BC-page_Installation .form-select-templates .list-templates .item .image {\n  position: relative;\n  overflow: hidden;\n}\n\n.BC-page_Installation .form-select-templates .list-templates .item-selected .image {\n  border: 2px solid #2c6ecb;\n  border-radius: 8px;\n  border-top-right-radius: 10px;\n}\n\n.BC-page_Installation .form-select-templates .list-templates .item .image .selected {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  width: 66;\n  border-top-left-radius: 2px;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 2px;\n  border-bottom-left-radius: 8px;\n  padding: 6px 8px;\n  background-color: #2c6ecb;\n  color: white;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form__Wrapper {\n  display: flex;\n  align-items: center;\n  column-gap: 8px;\n  margin-bottom: 2px;\n}\n\n.BC-page_Installation.Select-Theme\n  .NewUser\n  .BC-Shopify-Integration_Select-Theme-Form__Wrapper\n  .custom-select {\n  flex-grow: 1;\n  max-width: 450px;\n}\n\n.BC-page_Installation.Select-Theme\n  .NewUser\n  .BC-Shopify-Integration_Select-Theme-Form__Wrapper\n  .checkbox-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.BC-page_Installation.Select-Theme\n  .NewUser\n  .BC-Shopify-Integration_Select-Theme-Form__Wrapper\n  .BC-Select-Integration__value-container {\n  flex-wrap: nowrap;\n}\n\n.BC-page_Installation.Select-Theme .NewUser.select-theme-refresh {\n  height: 20px;\n  transition: all 0.4s;\n  cursor: pointer;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .select-theme-refresh.refreshing {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .BC-Shopify-Integration_Select-Theme-Form .btn-wrapper {\n  margin-top: 24px;\n  display: flex;\n  gap: 12px;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel-root {\n  height: 100%;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider {\n  height: 100%;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .slider-wrapper {\n  height: 100%;\n}\n\n.BC-page_Installation.Select-Theme\n  .NewUser\n  .preview\n  .carousel.carousel-slider\n  .slider-wrapper\n  .slider {\n  height: 100%;\n}\n\n.BC-page_Installation.Select-Theme\n  .NewUser\n  .preview\n  .carousel.carousel-slider\n  .slider-wrapper\n  .slider\n  .slide {\n  height: 100%;\n}\n\n.BC-page_Installation.Select-Theme\n  .NewUser\n  .preview\n  .carousel.carousel-slider\n  .slider-wrapper\n  .slider\n  .slide\n  > div {\n  height: 100%;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .preview .carousel.carousel-slider .control-dots .dot {\n  margin: 0 6px;\n  width: 6px;\n  height: 6px;\n  background-color: #c9ccd0;\n  opacity: 1;\n}\n\n.BC-page_Installation.Select-Theme\n  .NewUser\n  .preview\n  .carousel.carousel-slider\n  .control-dots\n  .dot.selected {\n  width: 10px;\n  height: 10px;\n  background-color: #ff3300;\n}\n\n.BC-page_Installation.Select-Theme .NewUser .finish-footer {\n  display: flex;\n  gap: 8px;\n  margin-top: 24px;\n}\n\n.BC-page_Installation.Select-Theme img.loading2 {\n  animation: rotation 2s infinite linear;\n}\n\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotation {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(359deg);\n  }\n}\n\n/**\n * ==============================================\n * Dot Flashing\n * ==============================================\n */\n.BC-page_Installation .dot-flashing {\n  position: relative;\n  width: 8px;\n  height: 8px;\n  border-radius: 5px;\n  background-color: #202223;\n  color: #202223;\n  animation: dot-flashing 1s infinite linear alternate;\n  animation-delay: 0.5s;\n}\n\n.BC-page_Installation .dot-flashing::before,\n.dot-flashing::after {\n  content: '';\n  display: inline-block;\n  position: absolute;\n  top: 0;\n}\n\n.BC-page_Installation .dot-flashing::before {\n  left: -14px;\n  width: 8px;\n  height: 8px;\n  border-radius: 5px;\n  background-color: #202223;\n  color: #202223;\n  animation: dot-flashing 1s infinite alternate;\n  animation-delay: 0s;\n}\n\n.BC-page_Installation .dot-flashing::after {\n  left: 14px;\n  width: 8px;\n  height: 8px;\n  border-radius: 5px;\n  background-color: #202223;\n  color: #202223;\n  animation: dot-flashing 1s infinite alternate;\n  animation-delay: 1s;\n}\n\n@keyframes dot-flashing {\n  0% {\n    background-color: #202223;\n  }\n\n  50%,\n  100% {\n    background-color: rgba(152, 128, 255, 0.2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
